var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",style:({maxWidth:_vm.maxwidth})},[_c('UIImage',{attrs:{"size":"224:60","bgsize":"contain","src":_vm.path,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }